import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../components/index-pc'),
    meta: {
      title: 'index',
      requiresAuth: true,
      mobileAlternative: 'index-mobile'
    }
  },
  {
    path: '/',
    name: 'index-mobile',
    component: () => import('../components/index-mobile'),
    meta: {
      title: 'index',
      requiresAuth: true
    }
  },

  {
    path: '/order',
    name: 'order',
    component: () => import('../components/order-pc'),
    meta: {
      title: 'order',
      requiresAuth: true,
      mobileAlternative: 'order-mobile' 
    }
  },
  {
    path: '/order',
    name: 'order-mobile',
    component: () => import('../components/order-mobile'),
    meta: {
      title: 'order',
      requiresAuth: true
    }
  },

  {
    path: '/management-login',
    name: 'login',
    component: () => import('../components/login'),
    meta: {
      title: 'login',
      requiresAuth: true,
      mobileAlternative: 'login-mobile' 
    }
  },
  {
    path: '/management-login',
    name: 'login-mobile',
    component: () => import('../components/login-mobile'),
    meta: {
      title: 'login',
      requiresAuth: true
    }
  },
  {
    path: '/login',
    redirect: { name: 'index' }
  },
  {
    path: '/menus',
    name: 'menus',
    component: () => import('../components/menus'),
    meta: {
      title: 'menus',
      requiresAuth: true,
      mobileAlternative: 'menus-mobile' 
    }
  },
  {
    path: '/menus',
    name: 'menus-mobile',
    component: () => import('../components/menus-mobile'),
    meta: {
      title: 'menus',
      requiresAuth: true,
    }
  },

  {
    path: '/adminmenus',
    name: 'adminmenus',
    component: () => import('../components/menus-admin'),
    meta: {
      title: 'adminmenus',
      requiresAuth: true,
      mobileAlternative: 'adminmenus-mobile' 
    }
  },
  {
    path: '/adminmenus',
    name: 'adminmenus-mobile',
    component: () => import('../components/menus-admin-mobile'),
    meta: {
      title: 'adminmenus',
      requiresAuth: true,
    }
  },

  {
    path: '/dispatchmenus',
    name: 'dispatchmenus',
    component: () => import('../components/dispatchmenus'),
    meta: {
      title: 'dispatchmenus',
      requiresAuth: true,
      mobileAlternative: 'dispatchmenus-mobile' 
    }
  },
  {
    path: '/dispatchmenus',
    name: 'dispatchmenus-mobile',
    component: () => import('../components/dispatchmenus-mobile'),
    meta: {
      title: 'dispatchmenus',
      requiresAuth: true,
    }
  },

  {
    path: '/today',
    name: 'today',
    component: () => import('../components/today'),
    meta: {
      title: 'today',
      requiresAuth: true,
      mobileAlternative: 'today-mobile'
    }
  },
  {
    path: '/today',
    name: 'today-mobile',
    component: () => import('../components/today-mobile'),
    meta: {
      title: 'today-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/lookup',
    name: 'lookup',
    component: () => import('../components/lookup'),
    meta: {
      title: 'lookup',
      requiresAuth: true,
      mobileAlternative: 'lookup-mobile'
    }
  },
  {
    path: '/lookup',
    name: 'lookup-mobile',
    component: () => import('../components/lookup-mobile'),
    meta: {
      title: 'lookup-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/contractor',
    name: 'contractor',
    component: () => import('../components/contractor'),
    meta: {
      title: 'contractor',
      requiresAuth: true,
      mobileAlternative: 'contractor-mobile'
    }
  },
  {
    path: '/contractor',
    name: 'contractor-mobile',
    component: () => import('../components/contractor-mobile'),
    meta: {
      title: 'contractor-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/lookupparts',
    name: 'lookupparts',
    component: () => import('../components/lookupparts'),
    meta: {
      title: 'lookupparts',
      requiresAuth: true,
      mobileAlternative: 'lookupparts-mobile'
    }
  },
  {
    path: '/lookupparts',
    name: 'lookupparts-mobile',
    component: () => import('../components/lookupparts-mobile'),
    meta: {
      title: 'lookupparts-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/techsupport',
    name: 'techsupport',
    component: () => import('../components/techsupport'),
    meta: {
      title: 'techsupport',
      requiresAuth: true,
      mobileAlternative: 'techsupport-mobile'
    }
  },
  {
    path: '/techsupport',
    name: 'techsupport-mobile',
    component: () => import('../components/techsupport-mobile'),
    meta: {
      title: 'techsupport-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/workdetail',
    name: 'workdetail',
    component: () => import('../components/workdetail'),
    meta: {
      title: 'workdetail',
      requiresAuth: true,
      mobileAlternative: 'workdetail-mobile'
    }
  },
  {
    path: '/workdetail',
    name: 'workdetail-mobile',
    component: () => import('../components/workdetail-mobile'),
    meta: {
      title: 'workdetail-mobile',
      requiresAuth: true,
    }
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: () => import('../components/invoice-form'),
    meta: {
      title: 'invoice',
      requiresAuth: true
    }
  },

  {
    path: '/contractordetail',
    name: 'contractordetail',
    component: () => import('../components/contractordetail'),
    meta: {
      title: 'contractordetail',
      requiresAuth: true,
      mobileAlternative: 'contractordetail-mobile'
    }
  },
  {
    path: '/contractordetail',
    name: 'contractordetail-mobile',
    component: () => import('../components/contractordetail-mobile'),
    meta: {
      title: 'contractordetail-mobile',
      requiresAuth: true,
    }
  },
  {
    path: '/contractor-workorder-search',
    name: 'contractor-workorder-search',
    component: () => import('../components/contractor-workorder-search'),
    meta: {
      title: 'contractor-workorder-search',
      requiresAuth: true,
      mobileAlternative: 'contractor-workorder-search-mobile'
    }
  },
  {
    path: '/contractor-workorder-search',
    name: 'contractor-workorder-search-mobile',
    component: () => import('../components/contractor-workorder-search-mobile'),
    meta: {
      title: 'contractor-workorder-search-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/mailbox',
    name: 'mailbox',
    component: () => import('../components/mailbox'),
    meta: {
      title: 'mailbox',
      requiresAuth: true,
      mobileAlternative: 'mailbox-mobile'
    }
  },
  {
    path: '/mailbox',
    name: 'mailbox-mobile',
    component: () => import('../components/mailbox-mobile'),
    meta: {
      title: 'mailbox-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/sendmail',
    name: 'sendmail',
    component: () => import('../components/sendmail'),
    meta: {
      title: 'sendmail',
      requiresAuth: true,
      mobileAlternative: 'sendmail-mobile'
    }
  },
  {
    path: '/sendmail',
    name: 'sendmail-mobile',
    component: () => import('../components/sendmail-mobile'),
    meta: {
      title: 'sendmail-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/maildetail',
    name: 'maildetail',
    component: () => import('../components/maildetail'),
    meta: {
      title: 'maildetail',
      requiresAuth: true,
      mobileAlternative: 'maildetail-mobile'
    }
  },
  {
    path: '/maildetail',
    name: 'maildetail-mobile',
    component: () => import('../components/maildetail-mobile'),
    meta: {
      title: 'maildetail-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../components/dashboard'),
    meta: {
      title: 'dashboard',
      requiresAuth: true,
      mobileAlternative: 'dashboard-mobile'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard-mobile',
    component: () => import('../components/dashboard-mobile'),
    meta: {
      title: 'dashboard-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/analyze',
    name: 'analyze',
    component: () => import('../components/analyze'),
    meta: {
      title: 'analyze',
      requiresAuth: true,
      mobileAlternative: 'analyze-mobile'
    }
  },
  {
    path: '/analyze',
    name: 'analyze-mobile',
    component: () => import('../components/analyze-mobile'),
    meta: {
      title: 'analyze-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/dispatcher',
    name: 'dispatcher',
    component: () => import('../components/dispatcher'),
    meta: {
      title: 'dispatcher',
      requiresAuth: true,
      mobileAlternative: 'dispatcher-mobile'
    }
  },
  {
    path: '/dispatcher',
    name: 'dispatcher-mobile',
    component: () => import('../components/dispatcher-mobile'),
    meta: {
      title: 'dispatcher-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/technician',
    name: 'technician',
    component: () => import('../components/technician'),
    meta: {
      title: 'technician',
      requiresAuth: true,
      mobileAlternative: 'technician-mobile'
    }
  },
  {
    path: '/technician',
    name: 'technician-mobile',
    component: () => import('../components/technician-mobile'),
    meta: {
      title: 'technician-mobile',
      requiresAuth: true,
    }
  },

  {
    path: '/goods',
    name: 'goods',
    component: () => import('../components/goods'),
    meta: {
      title: 'goods',
      requiresAuth: true,
      mobileAlternative: 'goods-mobile'
    }
  },
  {
    path: '/goods',
    name: 'goods-mobile',
    component: () => import('../components/goods-mobile'),
    meta: {
      title: 'goods-mobile',
      requiresAuth: true,
    }
  },
  {
    path: '/comment',
    name: 'comment',
    component: () => import('../components/comment'),
    meta: {
      title: 'comment',
      requiresAuth: true,
      mobileAlternative: 'comment-mobile'
    }
  },
  {
    path: '/comment',
    name: 'comment-mobile',
    component: () => import('../components/comment-mobile'),
    meta: {
      title: 'comment-mobile',
      requiresAuth: true,
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  localStorage.setItem("previousPage", from.fullPath || "/");

  const query = { ...to.query };

  if (window.innerWidth < 900 && to.meta.mobileAlternative) {
    next({ name: to.meta.mobileAlternative, query: query });
    return;
  }

  next();
})

export default router